import React from 'react';

function Footer() {
  return (
    <div className="sub_footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div className="cons_light_copyright">
              
            </div>
          </div>
          <div className="col-lg-5 text-right"></div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
